import { render, staticRenderFns } from "./AssignedProductsDrawer.vue?vue&type=template&id=6feca8ff&scoped=true&"
import script from "./AssignedProductsDrawer.vue?vue&type=script&lang=js&"
export * from "./AssignedProductsDrawer.vue?vue&type=script&lang=js&"
import style0 from "./AssignedProductsDrawer.vue?vue&type=style&index=0&id=6feca8ff&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6feca8ff",
  null
  
)

export default component.exports